// extracted by mini-css-extract-plugin
export default {"container":"Password_container__gSfgb","copy":"Password_copy__F1MKI"};